import {
  getLeoUuid,
  LeoUUID,
  getObject,
} from "@surya-digital/leo-ts-types";
import { SurveySettingDialogProperties, SurveySettingDialogPropertiesDTO } from "../types/surveySettingDialogProperties";


export namespace ChatSurveyNextAction {
  export interface StartSurveyDTO {
    case: string;
  }
  
  export class StartSurvey {
    readonly isChatSurveyNextActionStartSurvey: boolean = true;
  
  
  
  
  
    toDTO(): StartSurveyDTO {
      const dto: StartSurveyDTO = {
        case: "START_SURVEY",
      };
      return dto;
    }
    }
  
  StartSurvey.prototype.toString = function toString(): string {
    return `ChatSurveyNextAction.START_SURVEY()`;
  };
  
  export interface CompleteQuestionDTO {
    case: string;
    questionId: string;
  }
  
  export class CompleteQuestion {
    readonly isChatSurveyNextActionCompleteQuestion: boolean = true;
  
    readonly questionId: LeoUUID;
  
  
    constructor(
    questionId: LeoUUID
    ) {
      this.questionId = questionId;
    }
  
    static fromDTO(dto: CompleteQuestionDTO): CompleteQuestion {
      const questionId = getLeoUuid(dto, "questionId", InvalidChatSurveyNextActionCompleteQuestionQuestionIdError);
      return new CompleteQuestion(
        questionId
      );
    }
  
    toDTO(): CompleteQuestionDTO {
      const dto: CompleteQuestionDTO = {
        case: "COMPLETE_QUESTION",
          questionId: this.questionId.toDTO()
      };
      return dto;
    }
    }
  
  CompleteQuestion.prototype.toString = function toString(): string {
    return `ChatSurveyNextAction.COMPLETE_QUESTION(questionId='${this.questionId}')`;
  };
  
  export interface SubmitConfirmationRequiredDTO {
    case: string;
    submitConfirmationDialogProperties: SurveySettingDialogPropertiesDTO;
  }
  
  export class SubmitConfirmationRequired {
    readonly isChatSurveyNextActionSubmitConfirmationRequired: boolean = true;
  
    readonly submitConfirmationDialogProperties: SurveySettingDialogProperties;
  
  
    constructor(
    submitConfirmationDialogProperties: SurveySettingDialogProperties
    ) {
      this.submitConfirmationDialogProperties = submitConfirmationDialogProperties;
    }
  
    static fromDTO(dto: SubmitConfirmationRequiredDTO): SubmitConfirmationRequired {
      const submitConfirmationDialogProperties = SurveySettingDialogProperties.fromDTO(getObject(dto, "submitConfirmationDialogProperties", InvalidChatSurveyNextActionSubmitConfirmationRequiredSubmitConfirmationDialogPropertiesError));
      return new SubmitConfirmationRequired(
        submitConfirmationDialogProperties
      );
    }
  
    toDTO(): SubmitConfirmationRequiredDTO {
      const dto: SubmitConfirmationRequiredDTO = {
        case: "SUBMIT_CONFIRMATION_REQUIRED",
          submitConfirmationDialogProperties: this.submitConfirmationDialogProperties.toDTO()
      };
      return dto;
    }
    }
  
  SubmitConfirmationRequired.prototype.toString = function toString(): string {
    return `ChatSurveyNextAction.SUBMIT_CONFIRMATION_REQUIRED(submitConfirmationDialogProperties='${this.submitConfirmationDialogProperties}')`;
  };
  
  export interface SurveyCompletedDTO {
    case: string;
  }
  
  export class SurveyCompleted {
    readonly isChatSurveyNextActionSurveyCompleted: boolean = true;
  
  
  
  
  
    toDTO(): SurveyCompletedDTO {
      const dto: SurveyCompletedDTO = {
        case: "SURVEY_COMPLETED",
      };
      return dto;
    }
    }
  
  SurveyCompleted.prototype.toString = function toString(): string {
    return `ChatSurveyNextAction.SURVEY_COMPLETED()`;
  };
  

  export type ChatSurveyNextAction = StartSurvey | CompleteQuestion | SubmitConfirmationRequired | SurveyCompleted;

  export type ChatSurveyNextActionDTO = StartSurveyDTO | CompleteQuestionDTO | SubmitConfirmationRequiredDTO | SurveyCompletedDTO;

  export const fromDTO = (dto: ChatSurveyNextActionDTO): ChatSurveyNextAction => {
    switch (dto.case) {
      case "START_SURVEY":
          return new StartSurvey();
      case "COMPLETE_QUESTION":
          return CompleteQuestion.fromDTO(dto as CompleteQuestionDTO);
      case "SUBMIT_CONFIRMATION_REQUIRED":
          return SubmitConfirmationRequired.fromDTO(dto as SubmitConfirmationRequiredDTO);
      case "SURVEY_COMPLETED":
          return new SurveyCompleted();
      default:
        throw new InvalidChatSurveyNextActionError(
            `Case ${dto.case} is not valid case of ChatSurveyNextAction.`
        );
    }
  };
}

export class InvalidChatSurveyNextActionError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyNextActionError";
  }
}
export class InvalidChatSurveyNextActionStartSurveyError extends InvalidChatSurveyNextActionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyNextActionStartSurveyError";
  }
}

export class InvalidChatSurveyNextActionCompleteQuestionError extends InvalidChatSurveyNextActionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyNextActionCompleteQuestionError";
  }
}

export class InvalidChatSurveyNextActionCompleteQuestionQuestionIdError extends InvalidChatSurveyNextActionCompleteQuestionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyNextActionCompleteQuestionQuestionIdError";
  }
}

export class InvalidChatSurveyNextActionSubmitConfirmationRequiredError extends InvalidChatSurveyNextActionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyNextActionSubmitConfirmationRequiredError";
  }
}

export class InvalidChatSurveyNextActionSubmitConfirmationRequiredSubmitConfirmationDialogPropertiesError extends InvalidChatSurveyNextActionSubmitConfirmationRequiredError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyNextActionSubmitConfirmationRequiredSubmitConfirmationDialogPropertiesError";
  }
}

export class InvalidChatSurveyNextActionSurveyCompletedError extends InvalidChatSurveyNextActionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyNextActionSurveyCompletedError";
  }
}
